import { useSelector } from "react-redux";
import config from "./config";
import Draggable from "react-draggable";
import { Paper } from "@mui/material";
import { getAuth0IdToken } from "./auth";
const moment = require("moment");

export const getDt = (str) => {
  if (str === undefined || str === null || str === '') return null;
  var date = new Date(str),
    mnth = ("0" + (date.getMonth() + 1)).slice(-2),
    day = ("0" + date.getDate()).slice(-2);
  var currentdate = new Date();
  var datetime =
    currentdate.getHours() +
    ":" +
    currentdate.getMinutes() +
    ":" +
    currentdate.getSeconds();
  return [date.getFullYear(), mnth, day].join("-") + " " + datetime;
};

export const getPrjStatus = (projStat, find) => {
  return projStat.find((val) => val.value === find)?.label;
};

export const getDtfrmt = (val) => {
  return moment(new Date(val)).format("DD-MMM-YYYY");
};


export const showHideElem = (id, action) => {
  if (document.getElementById(id) !== null) {
    if (action === "show") {
      document.getElementById(id).style.display = "block";
    } else {
      document.getElementById(id).style.display = "none";
    }
  }
};

export const fetchUsers = async (srchToken) => {
  let users = [];
  const searchParam = encodeURIComponent(srchToken);
  try {
    const token = await getAuth0IdToken()
    const response = await fetch(`${config.CADMIN_URL}/getADSrchs/${searchParam}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'X-Token-Type': 'auth0'
      }
    });
    const data = await response.json();
    users = data.value;
    if (response?.status === 403) {
      return response.status;
    }
  } catch (error) {
    console.log(error);
  }
  return users;
};

//input format = 'YYYY-MM-DDThh:mm:ss'
export function dateFmtToStr(date1) {
  const date = new Date(date1);
  let d = new Intl.DateTimeFormat('en-GB', { year: "numeric", month: "short", day: "2-digit" }).format(date).split(" ").join("-");
  return d;
}



export const fetchAppAccUsers = async () => {
  let users = [];
  try {
    const token = await getAuth0IdToken()
    const response = await fetch(`${config.PGAPI_URL}/getAppAccAR/PRJWSC`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'X-Token-Type': 'auth0'
      }
    });
    const data = await response.json();
    users = data;
    if (response?.status === 403) {
      return response.status;
    }
  } catch (error) {
    console.log(error);
  }
  return users;
};


export const fetchActiveUsers = async () => {
  //fetching active user roles for PRJWSC (prevously active app accesses were being used)
  let data
  try {
    const token = await getAuth0IdToken()
    const response = await fetch(`${config.CADMIN_URL}/getUserRoleAR/?PApplication=PRJWSC`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'X-Token-Type': 'auth0'
      }
    });
    data = await response.json();

    if (response?.status === 403) {
      return response.status;
    }
  } catch (error) {
    console.log(error);
  }
  //modifying user role object to match logic in permissions page
  const users = data.map((obj) => ({
    app_name: obj.application,
    display_Name: obj.display_name,
    email_id: obj.email,
    first_name: obj.first_name,
    given_name: obj.given_name,
    job_title: obj.job_title,
    last_name: obj.last_name,
    mobile_phone: obj.mobile_phone,
    office_location: obj.office_location,
    surname: obj.surname,
  }))

  // console.log(newUsers, "--newUsers roles in fetch active users--")
  return users;
};

export const debounce = (fn) => {
  let timer;
  return function (...args) {
    const context = this;
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      if (args[0].key !== "Enter") {
        fn.apply(context, args);
      }
    }, 500);
  };
};

export const eYear = () => {
  return moment(new Date()).year();
}

export default getDt;

export const getTTLabel = (TT, find) => {
  //return TT.find((val) => val.lookup_line_id == find)?.description;
  return TT.find((val) => val.lookup_code == find)?.description;
};

export const dateComparator = (date1, date2) => {
  const date1Number = monthToComparableNumber(date1);
  const date2Number = monthToComparableNumber(date2);
  if (date1Number === null && date2Number === null) {
    return 0;
  }
  if (date1Number === null) {
    return -1;
  }
  if (date2Number === null) {
    return 1;
  }
  return date1Number - date2Number;
};

const monthToComparableNumber = (date) => {
  let dateF2 = date.replace(/Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec/gi, function (x) {
    if (x === "Jan") { return "01" };
    if (x === "Feb") { return "02" };
    if (x === "Mar") { return "03" };
    if (x === "Apr") { return "04" };
    if (x === "May") { return "05" };
    if (x === "Jun") { return "06" };
    if (x === "Jul") { return "07" };
    if (x === "Aug") { return "08" };
    if (x === "Sep") { return "09" };
    if (x === "Oct") { return "10" };
    if (x === "Nov") { return "11" };
    if (x === "Dec") { return "12" };
  });

  if (dateF2 === undefined || dateF2 === null || dateF2.length !== 10) {
    return null;
  }
  const yearNumber = Number.parseInt(dateF2.substring(6, 10));
  const monthNumber = Number.parseInt(dateF2.substring(3, 5));
  const dayNumber = Number.parseInt(dateF2.substring(0, 2));
  return yearNumber * 10000 + monthNumber * 100 + dayNumber;
};


export const numberComparator = (number1, number2) => {
  const number1Number = numberFilter(number1);
  const number2Number = numberFilter(number2);
  if (number1Number === null && number2Number === null) {
    return 0;
  }
  if (number1Number === null) {
    return -1;
  }
  if (number2Number === null) {
    return 1;
  }
  return number1Number - number2Number;
};

// const numberFilter = (str) => {
//   let numberF1 = str.replace(/[A-Za-z|-]/gi, '');
//   let numberF2 = numberF1.replace(/[' ']/gi, '');
//   return numberF2;
// }
const numberFilter = (str) => {
  if (!str) {
    return ''; // Return an empty string if `str` is null or undefined
  }
  let numberF1 = str.replace(/[A-Za-z|-]/gi, '');
  let numberF2 = numberF1.replace(/[' ']/gi, '');
  return numberF2;
};

export const getNumber = (nb) => {
  if (!nb) {
    return 0; // Return 0 if `nb` is null or undefined
  }
  let tempNumber = nb.replaceAll(',', '');
  return Number(tempNumber);
};

// export const getNumber = (nb) => {
//   let tempNumber = 0;
//   if (nb) {
//     tempNumber = nb.replaceAll(',', '');
//   }
//   return Number(tempNumber);
// }

export const addCommas = (params, lookup_code) => {
  const fieldValue = getNumber(params.data[lookup_code])
  return fieldValue ? Number(fieldValue).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') : null
}

export const fetchProductsById = async (id) => {
  let products;
  try {
    const token = await getAuth0IdToken()
    const response = await fetch(`${config.PGAPI_URL}/getPWSHdrs/?pno=${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'X-Token-Type': 'auth0'
      }
    });
    products = await response.json();
    if (response?.status === 403) {
      return response.status;
    }
  } catch (error) {
    console.log(error);
  }
  return products;
};

export const useProjBuCode = () => {
  const { buLkp } = useSelector((state) => state.ctrl)
  const { world_area } = useSelector((state) => state.ctrl.data)

  return buLkp.find(o => o.meaning == world_area)?.lookup_code
}

export const arraysContainSameElements = (arr1, arr2) => {
  return arr1?.every(val => arr2?.includes(val)) && arr2?.every(val => arr1?.includes(val))

}

export const getAgGridIndexofSelectedRows = (getSelectedNodes) => {
  // rows order will get based on the current index of the AG grid

  let getNodeArray = [];
  let getSortedRow = [];
  let getSortedNode = [];

  let getNode = getSelectedNodes;

  getNode.map((node) => {
    let tempNode = {
      rowIndex: 0,
      data: 0,
    };
    Object.entries(node).map((x) => {
      if (x[0] === "rowIndex") {
        tempNode.rowIndex = x[1];
      }
      if (x[0] === "data") {
        tempNode.data = x[1];
      }
    });
    getNodeArray.push(tempNode);
  });

  getSortedNode = getNodeArray?.sort((a, b) =>
    a.rowIndex > b.rowIndex ? 1 : -1
  );

  if (getNodeArray.length > 0) {
    getNodeArray.map((x) => {
      getSortedRow.push(x.data);
    });
  }
  return getSortedRow;
}

export const getEnvironment = () => {
  const url = window.location.host;
  if (url.includes("localhost")) return "local";
  if (url.includes("dev")) return "development";
  if (url.includes("stg")) return "stage";
  if (url.includes("prjws-beta")) return "productionbeta";
  if (url.includes("prjws") || url.includes("myprojectworkspace")) return "production";
  return "development"; // default to development if no match
};

export const PaperComponent = (props) => {
  return (
    <Draggable handle="#draggable-dialog-title">
      <Paper {...props} />
    </Draggable>
  );
}

export const statusBar = {
  statusPanels: [
    { statusPanel: "agTotalRowCountComponent", align: "left" },
    { statusPanel: "agSelectedRowCountComponent", align: "left" },
  ],
};

// export const getOktaToken = () => {
//   // const token = JSON.parse(localStorage.getItem('okta-token-storage'))?.idToken?.idToken;
//   const token = 'eyJraWQiOiJsbzlyZmRmWmtWQm5wQklLN1BEN0RhVml2SXZULUp4eG00RFZmQ0t0S3RjIiwiYWxnIjoiUlMyNTYifQ.eyJzdWIiOiIwMHVoNzhpNzU4V0xQeExkZTJwNyIsIm5hbWUiOiJTaWRodSwgSGVybWFuIFtFTVIvRU5UL0lUL01PSEFdIiwiZW1haWwiOiJoZXJtYW4uc2lkaHVAZW1lcnNvbi5jb20iLCJ2ZXIiOjEsImlzcyI6Imh0dHBzOi8vZW1lcnNvbi5va3RhLmNvbS9vYXV0aDIvZGVmYXVsdCIsImF1ZCI6IjBvYWZkNnBvYzQxZGdFaXBBMnA3IiwiaWF0IjoxNzUwMzE0Nzg1LCJleHAiOjE3NTAzMTgzODUsImp0aSI6IklELmhXNEF6bW5QWHBVVWZ5NllWOWFYdGpfczhmZ1paQzJjOFdmc2RQQ09zR0UiLCJhbXIiOlsicHdkIl0sImlkcCI6IkRTU08iLCJub25jZSI6IkY5VmtjcnhCazlIRGNnSHlncmNCVjRhdjNySEJ0bEU5VUFHRTZOMWkyRTdxT0JEbndrb3QxYmwxRGNJWEtQYWsiLCJwcmVmZXJyZWRfdXNlcm5hbWUiOiJoZXJtYW4uc2lkaHVAZW1lcnNvbi5jb20iLCJnaXZlbl9uYW1lIjoiSGVybWFuIiwiZmFtaWx5X25hbWUiOiJTaWRodSIsImF1dGhfdGltZSI6MTc1MDMxMzgwMSwiYXRfaGFzaCI6IlZITXd3Wm9MWFNFSnZJc0Z3bFduMFEifQ.WtPBP3MQb8ZD61RrRcJsovu2luWtzfO8L14KG3SpAaA6mnl4MmT7f0Wqo45zfH9QXrUR6HRTPYcLp5KNAREG8r5r-Yh1atyXbP9lxJuWT8un3x0QXCKo0_goDTMlDswRR8wwzEE6LLYzSohca53qNueLS6ZoWPgaW8bDd1TxlhGT8CeCTDN_fFerRfxbc30lrk604KKFEvXLLVMFcKCLDqsYXejvQHJhLm9trLZU3aNxLwb7FIJbwoBOO5fhSPTdsJ3KcAJhDipAqDJuXOiNeIGXySLQxvTDxqXY2wsUsR3q5cmdmQQsfgyL3qW8eyQVbh-vtot8knWTvhSztiHObQ'
//   if (token) {
//     return `Bearer ${token}`;
//   } else {
//     return null;
//   }
// }

function stringToBytes(string) {
  const charList = string.split('');
  const uintArray = [];
  for (let i = 0; i < charList.length; i++) {
    uintArray.push(charList[i].charCodeAt(0));
  }
  return uintArray;
}

function bytesToString(aBytes) {
  let sView = "";

  for (let nPart, nLen = aBytes.length, nIdx = 0; nIdx < nLen; nIdx++) {
    nPart = aBytes[nIdx];

    sView += String.fromCharCode(
      nPart > 251 && nPart < 254 && nIdx + 5 < nLen ? /* six bytes */
        (nPart - 252) * 1073741824 + (aBytes[++nIdx] - 128 << 24) + (aBytes[++nIdx] - 128 << 18) + (aBytes[++nIdx] - 128 << 12) + (aBytes[++nIdx] - 128 << 6) + aBytes[++nIdx] - 128
        : nPart > 247 && nPart < 252 && nIdx + 4 < nLen ? /* five bytes */
          (nPart - 248 << 24) + (aBytes[++nIdx] - 128 << 18) + (aBytes[++nIdx] - 128 << 12) + (aBytes[++nIdx] - 128 << 6) + aBytes[++nIdx] - 128
          : nPart > 239 && nPart < 248 && nIdx + 3 < nLen ? /* four bytes */
            (nPart - 240 << 18) + (aBytes[++nIdx] - 128 << 12) + (aBytes[++nIdx] - 128 << 6) + aBytes[++nIdx] - 128
            : nPart > 223 && nPart < 240 && nIdx + 2 < nLen ? /* three bytes */
              (nPart - 224 << 12) + (aBytes[++nIdx] - 128 << 6) + aBytes[++nIdx] - 128
              : nPart > 191 && nPart < 224 && nIdx + 1 < nLen ? /* two bytes */
                (nPart - 192 << 6) + aBytes[++nIdx] - 128
                : /* nPart < 127 ? */ /* one byte */
                nPart
    );
  }

  return sView;
}

function fixUTF8String(str) {
  try {
    const byteArr = stringToBytes(str);
    const fixedStr = bytesToString(byteArr);
    return fixedStr;
  } catch (error) {
    console.warn('Error fixing UTF-8 string:', error);
    return str;
  }
}

export function fixUTF8Recursive(obj) {
  if (typeof obj === 'string') {
    return fixUTF8String(obj);
  } else if (Array.isArray(obj)) {
    return obj.map(item => fixUTF8Recursive(item));
  } else if (obj && typeof obj === 'object' && obj !== null) {
    const fixed = {};
    for (const [key, value] of Object.entries(obj)) {
      fixed[key] = fixUTF8Recursive(value);
    }
    return fixed;
  }
  return obj;
}

export const useOrgId = () => {
  const buOffice = useSelector((state) => state.ctrl.buLkp);
  const operatingUnit = useSelector((state) => state.ctrl.data.operating_unit);

  const getOrgIdFromDivisionCode = (divisionCode) => {

    // Filter buOffice to prioritize the one matching operatingUnit
    const filteredBuOffice = buOffice.filter((office) => office.meaning === operatingUnit);

    // Use the filtered list if available, otherwise fallback to the original buOffice
    const lookupList = filteredBuOffice.length > 0 ? filteredBuOffice : buOffice;

    const matchedOffice = lookupList.find((office) => {
      if (office.attribute1) {
        const attributeObject = office.attribute1.split(",").reduce((acc, item) => {
          const [key, value] = item.split(":");
          if (key && value) {
            acc[key.trim()] = value.trim();
          }
          return acc;
        }, {});
        return Object.keys(attributeObject).includes(divisionCode);
      }
      return false;
    });


    if (matchedOffice && matchedOffice.attribute1) {
      const attributeObject = matchedOffice.attribute1.split(",").reduce((acc, item) => {
        const [key, value] = item.split(":");
        if (key && value) {
          acc[key.trim()] = value.trim();
        }
        return acc;
      }, {});
      return attributeObject[divisionCode] || null;
    }

    return null;
  };

  return { getOrgIdFromDivisionCode };
};